import { createAsyncThunk } from '@reduxjs/toolkit'

import { calculateGridFittingApi } from '../../api'
import type { CreateMapFetching } from '../../types'
import { mapFetchingSlice } from './mapFetchingSlice'

export const { clearMapFetching } = mapFetchingSlice.actions

export const calculateMapFetching = createAsyncThunk(
  'MapFetching',
  async ({ projectId, mapId, newMapName, markerName }: CreateMapFetching) => {
    return calculateGridFittingApi(projectId, mapId, newMapName, markerName)
  },
)
